import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { HBox } from '../../../components/Box';
import { Check, Times } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { selectWork } from '../../Api/selectors';
import { REQUEST_VIES_CHECK } from '../constants';

export function ViesLabelComp(props) {
  if (props.checkWork) return <Loader small />;
  return (
    <HBox left>
      <strong>VIES</strong>
      {props.vies ? (
        <div style={{ color: 'green' }}>
          <Check />
        </div>
      ) : (
        <div style={{ color: 'red' }}>
          <Times />
        </div>
      )}
    </HBox>
  );
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    checkWork: selectWork(`${REQUEST_VIES_CHECK}_${ownProps.companyId}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ViesLabel = compose(
  withConnect,
  withRouter,
)(ViesLabelComp);
